<div class="form-date-picker {{config.class}}" [formGroup]="group"  >
        <div for="" class="default-sub-header text-label label-section">
                {{config.label | translate}}
                <span *ngIf="config.icon" class="view-icon" (click)="tooltip.toggle()" #tooltip="matTooltip" matTooltipPosition="right"  matTooltip="{{config.toolTip}}" class="{{config.icon}}"></span></div>
 <mat-form-field class="basic-date-picker " [ngClass]="{'input-with-boundary':config.appearance}"  [formGroup]="group">


                <mat-label class="select-label">{{ config.label | translate}}</mat-label>
                <input [disabled]="config.disabled"  matInput [matDatepicker]="picker"  [matDatepickerFilter]="config.FrequencyTypeIds" (click)="picker.open()" readonly [formControlName]="config.name" [value]="config.value" [min]="config.minDate" [max]="config.maxDate" [attr.name]="config.name">
                <mat-datepicker-toggle class="seat-icon-color" matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
</mat-form-field>
</div>
